import { OrderItemSerializable } from './order-item-serializable';

export class CustomTermOrderItemSerializable extends OrderItemSerializable {
  termDays: number;
  termMonths: number;
}
